import React, { useEffect, useState } from 'react';
import ExecutiveEditorsList from '../ExecutiveEditorsList';
import { getExecutiveEditors } from '../../services/firebaseService';

const EditorialBoardContent = () => {
  const [editors, setEditors] = useState(null); // null means loading
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getExecutiveEditors().then(data => {
      setEditors(data);
      setLoading(false);
    });
  }, []);

  if (loading || editors === null) {
    console.log('EditorialBoardContent: Still loading, editors:', editors);
    return (
      <div className="py-10 bg-white rounded-lg shadow-md text-center text-gray-500 text-lg">
        Loading executive editors...
      </div>
    );
  }

  console.log('EditorialBoardContent: Rendering with editors:', editors);
  return (
    <div className="py-10 bg-white rounded-lg shadow-md">
      <h1 className="text-3xl font-extrabold text-accent mb-6 text-center">Editorial Board</h1>
      <div className="mb-10">
        <ExecutiveEditorsList editors={editors} />
      </div>
    </div>
  );
};

export default EditorialBoardContent; 



